import { render } from "./catalogMenuSmall.vue?vue&type=template&id=53da46a8&scoped=true"
import script from "./catalogMenuSmall.vue?vue&type=script&lang=js"
export * from "./catalogMenuSmall.vue?vue&type=script&lang=js"

import "./catalogMenuSmall.vue?vue&type=style&index=0&id=53da46a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53da46a8"]])

export default __exports__